import styled from 'styled-components'
import { theme } from '../../theme'

const ViewToolbar = styled.div`
	width: 100%;
	border-radius: ${theme.shape.borderRadius}px;
	display: flex;
	gap: 8px;
	color: white;
`

export default ViewToolbar
